// extracted by mini-css-extract-plugin
module.exports = {"projects":"projects_projects__Dt0wA","heading":"projects_heading__2prLY"};